import { render, staticRenderFns } from "./Oldpage.vue?vue&type=template&id=4be0506a&scoped=true&"
import script from "./Oldpage.vue?vue&type=script&lang=js&"
export * from "./Oldpage.vue?vue&type=script&lang=js&"
import style0 from "./Oldpage.vue?vue&type=style&index=0&id=4be0506a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be0506a",
  null
  
)

export default component.exports